module.exports = __webpack_public_path__ + "static/img/RASM1000_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM1000_1.png
// module id = 71gw
// module chunks = 0